import { useState, useRef } from "react";

const S = {
  root:         { fontFamily: "'Georgia','Times New Roman',serif", background: "#F7F4EF", minHeight: "100vh", color: "#1A1208" },
  header:       { background: "#1A1208", color: "#F7F4EF", padding: "28px 36px 24px", borderBottom: "3px solid #C9A84C" },
  headerTop:    { display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "16px", flexWrap: "wrap" },
  badge:        { display: "inline-block", fontSize: "10px", fontFamily: "'Courier New',monospace", fontWeight: "700", letterSpacing: "2px", textTransform: "uppercase", color: "#C9A84C", border: "1px solid #C9A84C", padding: "3px 10px", borderRadius: "2px", marginBottom: "10px" },
  title:        { margin: "0 0 6px", fontSize: "26px", fontWeight: "700", letterSpacing: "-0.3px", lineHeight: "1.2" },
  subtitle:     { margin: "0", fontSize: "13px", color: "#A89060", fontStyle: "italic" },
  body:         { padding: "28px 36px", maxWidth: "1100px" },
  card:         { background: "#FFFFFF", border: "1px solid #E0D8CC", borderRadius: "6px", padding: "24px", marginBottom: "20px", boxShadow: "0 1px 4px rgba(0,0,0,0.06)" },
  controlRow:   { display: "flex", gap: "12px", alignItems: "center", flexWrap: "wrap" },
  btn:          { display: "inline-flex", alignItems: "center", gap: "8px", padding: "11px 22px", border: "none", borderRadius: "4px", fontSize: "14px", fontFamily: "'Georgia',serif", fontWeight: "600", cursor: "pointer", letterSpacing: "0.2px" },
  btnPrimary:   { background: "#1A1208", color: "#F7F4EF" },
  btnSecondary: { background: "#F7F4EF", color: "#1A1208", border: "1px solid #C8BFA8" },
  btnExport:    { background: "#2E7D32", color: "#FFF" },
  btnUpload:    { background: "#1565C0", color: "#FFF" },
  uploadBox:    { border: "2px dashed #C9A84C", borderRadius: "6px", padding: "32px", textAlign: "center", background: "#FDFAF4", cursor: "pointer", marginBottom: "16px" },
  uploadIcon:   { fontSize: "36px", marginBottom: "10px" },
  uploadText:   { fontSize: "14px", color: "#6B5C3E", fontStyle: "italic" },
  uploadSub:    { fontSize: "12px", color: "#8C7B5E", marginTop: "6px" },
  summaryGrid:  { display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(200px,1fr))", gap: "14px", marginBottom: "24px" },
  summaryCard:  { borderRadius: "5px", padding: "16px 18px", borderLeft: "4px solid", cursor: "pointer" },
  summaryCount: { fontSize: "32px", fontWeight: "700", lineHeight: "1", marginBottom: "4px" },
  summaryLabel: { fontSize: "12px", fontWeight: "600", textTransform: "uppercase", letterSpacing: "0.8px", opacity: 0.75 },
  sectionTitle: { fontSize: "15px", fontWeight: "700", letterSpacing: "0.5px", textTransform: "uppercase", color: "#1A1208", borderBottom: "2px solid #E0D8CC", paddingBottom: "8px", marginBottom: "14px", marginTop: "0", display: "flex", alignItems: "center", gap: "10px" },
  table:        { width: "100%", borderCollapse: "collapse", fontSize: "13px" },
  th:           { textAlign: "left", padding: "9px 12px", fontFamily: "'Courier New',monospace", fontSize: "11px", letterSpacing: "1px", textTransform: "uppercase", color: "#6B5C3E", borderBottom: "2px solid #E0D8CC", fontWeight: "700", background: "#FAF8F4" },
  td:           { padding: "10px 12px", borderBottom: "1px solid #F0EBE1", verticalAlign: "top", lineHeight: "1.45" },
  catBadge:     { display: "inline-block", fontSize: "10px", fontWeight: "700", letterSpacing: "0.8px", textTransform: "uppercase", padding: "2px 8px", borderRadius: "2px", color: "#FFF" },
  errorBox:     { background: "#FFEBEE", border: "1px solid #EF9A9A", borderRadius: "4px", padding: "12px 16px", color: "#B71C1C", fontSize: "13px", marginTop: "12px" },
  emptyState:   { textAlign: "center", padding: "40px 20px", color: "#8C7B5E", fontStyle: "italic", fontSize: "14px" },
  tabRow:       { display: "flex", gap: "0", borderBottom: "2px solid #E0D8CC", marginBottom: "18px", flexWrap: "wrap" },
  tab:          { padding: "9px 18px", fontSize: "12px", fontWeight: "700", fontFamily: "'Courier New',monospace", letterSpacing: "0.8px", textTransform: "uppercase", border: "none", borderBottom: "3px solid transparent", background: "none", cursor: "pointer", color: "#8C7B5E", marginBottom: "-2px" },
  tabActive:    { color: "#1A1208", borderBottomColor: "#C9A84C" },
  infoBox:      { background: "#E3F2FD", border: "1px solid #90CAF9", borderRadius: "4px", padding: "12px 16px", fontSize: "13px", color: "#0D47A1", marginBottom: "16px", lineHeight: "1.6" },
  pillCode:     { fontFamily: "'Courier New',monospace", fontSize: "11px", background: "#F0EBE1", padding: "2px 6px", borderRadius: "3px", color: "#6B5C3E" },
  btnDanger: { background: "#C62828", color: "#FFF" },
};

const CATEGORIES = {
  SPS:    "sps",
  OTP:    "otp",
  OTHER:  "other",
};

const CATEGORY_LABELS = {
  [CATEGORIES.SPS]:   "Annual Benefit Statement — bounced",
  [CATEGORIES.OTP]:   "Login code (OTP) — bounced, safe to ignore",
  [CATEGORIES.OTHER]: "Other bounced mail",
};

const CATEGORY_COLORS = {
  [CATEGORIES.SPS]:   { bg: "#FFF3E0", border: "#F57C00", badge: "#E65100", text: "#BF360C" },
  [CATEGORIES.OTP]:   { bg: "#F3E5F5", border: "#6A1B9A", badge: "#4A148C", text: "#2D0060" },
  [CATEGORIES.OTHER]: { bg: "#ECEFF1", border: "#546E7A", badge: "#37474F", text: "#263238" },
};

// ─── Decode MIME encoded-word subject lines ────────────────────────────────────
// Handles the standard =?charset?Q?...?= / =?charset?B?...?= form, including
// subjects that wrap across multiple encoded-word chunks on separate lines
// (Outlook NDR bodies fold long subjects this way).
function decodeMimeSubject(raw) {
  if (!raw) return "";
  // Join folded lines: encoded-word chunks separated by whitespace/newlines
  const joined = raw.replace(/\?=\s+=\?/g, "?==?");
  let result = joined.replace(/=\?([^?]+)\?([QqBb])\?([^?]*)\?=/g, (_, charset, enc, text) => {
    if (enc.toUpperCase() === "Q") {
      // Quoted-printable: _ = space, =XX = hex byte
      const withSpaces = text.replace(/_/g, " ");
      return withSpaces.replace(/=([0-9A-Fa-f]{2})/g, (__, hex) =>
        String.fromCharCode(parseInt(hex, 16))
      );
    }
    if (enc.toUpperCase() === "B") {
      try { return atob(text); } catch (_) { return text; }
    }
    return text;
  });
  return result.replace(/\s+/g, " ").trim();
}

function classifySubject(decodedSubject) {
  const s = decodedSubject.toLowerCase();
  if (s.includes("single public service pension scheme") || s.includes("annual benefit statement")) {
    return CATEGORIES.SPS;
  }
  if (s.includes("beaumont portal") || s.includes("login code") || s.includes("verification code")) {
    return CATEGORIES.OTP;
  }
  return CATEGORIES.OTHER;
}

// ─── Parse one NDR body into a structured bounce record ───────────────────────
function parseNdrBody(body, fallbackDate) {
  // Recipient — the email address right after "Delivery has failed to these
  // recipients or groups:" (or just the first email-looking token in the body,
  // since Outlook CSV export sometimes strips the intro line).
  const recipientMatch =
    body.match(/recipients or groups:\s*\n?\s*([^\s@]+@[^\s@]+\.[^\s@]+)/i) ||
    body.match(/^\s*([^\s@]+@[^\s@]+\.[^\s@]+)/m);
  const recipient = recipientMatch ? recipientMatch[1].trim().replace(/[.,;]$/, "") : "";

  // Bounce reason — the "Remote server returned '...'" line, or the plain
  // explanation sentence if that's all that's present.
  const reasonMatch =
    body.match(/Remote server returned\s*'([^']+)'/i) ||
    body.match(/This message couldn't be delivered because[^\n]*/i);
  const reason = reasonMatch ? (reasonMatch[1] || reasonMatch[0]).trim() : "Unknown reason";

  // Original Message-ID — ties this bounce back to the exact email that was sent.
  const midMatch = body.match(/Message-ID:\s*<([^>]+)>/i);
  const messageId = midMatch ? midMatch[1].trim() : "";

  // Original Subject — may be MIME-encoded and folded across lines. Capture
  // everything from "Subject:" up to the next recognizable header or end.
  const subjMatch = body.match(/Subject:\s*([\s\S]*?)(?:\n[A-Za-z-]+:|\n*$)/i);
  const rawSubject = subjMatch ? subjMatch[1].replace(/\n/g, " ").trim() : "";
  const decodedSubject = decodeMimeSubject(rawSubject);

  // Original send timestamp — from the "Date:" header inside the NDR if present.
  const dateMatch = body.match(/\nDate:\s*([^\n]+)/i);
  const sentDate = dateMatch ? dateMatch[1].trim() : fallbackDate || "";

  return {
    recipient,
    reason,
    messageId,
    subject: decodedSubject || "(subject not found)",
    sentDate,
    category: classifySubject(decodedSubject),
  };
}



// ─── CSV Parser (same robust quoted-field parser as the query analyser) ───────
function parseOutlookCSV(text) {
  if (text.charCodeAt(0) === 0xFEFF) text = text.slice(1);

  let i = 0;
  function field() {
    if (text[i] === '"') {
      i++;
      let v = "";
      while (i < text.length) {
        if (text[i] === '"' && text[i + 1] === '"') { v += '"'; i += 2; }
        else if (text[i] === '"') { i++; break; }
        else v += text[i++];
      }
      return v;
    }
    let v = "";
    while (i < text.length && text[i] !== ',' && text[i] !== '\n' && text[i] !== '\r') v += text[i++];
    return v;
  }
  function line() {
    const fs = [];
    while (i < text.length && text[i] !== '\n' && text[i] !== '\r') {
      fs.push(field());
      if (text[i] === ',') i++;
    }
    if (text[i] === '\r') i++;
    if (text[i] === '\n') i++;
    return fs;
  }

  const headers = line();
  const col = (name) => headers.findIndex(h => h.trim() === name);
  const bodyIdx     = col('Body');
  const receivedIdx = col('Received');
  const subjectIdx  = col('Subject');

  const rows = [];
  while (i < text.length) {
    const fs = line();
    if (fs.length < 2) continue;
    const body = fs[bodyIdx] || '';
    if (!body.trim()) continue;
    const parsed = parseNdrBody(body, fs[receivedIdx]);
    // Skip rows that clearly aren't NDRs at all (no recipient found)
    if (!parsed.recipient) continue;
    rows.push(parsed);
  }

  // De-duplicate on (recipient + messageId) — the same bounce can sometimes
  // appear twice in an export (e.g. NDR + a manually forwarded copy).
  const seen = new Set();
  const deduped = [];
  for (const r of rows) {
    const key = (r.recipient + "|" + r.messageId).toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    deduped.push(r);
  }
  return deduped;
}

function ppsHintFromEmail(email) {
  return (email || "").split("@")[0];
}

export default function BouncedEmailAnalyser() {
  const [bounces, setBounces]     = useState([]);
  const [fileName, setFileName]   = useState("");
  const [error, setError]         = useState(null);
  const [activeTab, setActiveTab] = useState(CATEGORIES.SPS);
  const fileRef = useRef(null);

  const handleFile = (file) => {
    if (!file) return;
    if (!file.name.endsWith('.csv')) { setError("Please upload a .csv file exported from Outlook."); return; }
    setError(null);
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const parsed = parseOutlookCSV(e.target.result);
        if (!parsed.length) { setError("No bounce notifications found. Make sure this is a CSV export of the SPSnotSent folder."); return; }
        setBounces(parsed);
        setFileName(file.name);
      } catch (err) {
        setError("Failed to parse CSV: " + err.message);
      }
    };
    reader.readAsText(file, 'utf-8');
  };

  // Add near the top, with other state
const [year, setYear] = useState(new Date().getFullYear());
const [marking, setMarking] = useState(false);
const [markResult, setMarkResult] = useState(null);
const [showConfirm, setShowConfirm] = useState(false);

const API_BASE = window.location.hostname === 'localhost'
  ? 'http://localhost:5800'
  : '';

const markAsFailed = async () => {
  setShowConfirm(false);
  setMarking(true);
  setMarkResult(null);

  const csrf = document.cookie
    .split('; ')
    .find(r => r.startsWith('csrf-token='))
    ?.split('=')[1] || '';

  try {
    const entries = filtered.map(r => ({ email: r.recipient, reason: r.reason }));
    const res = await fetch(`${API_BASE}/api/email/mark-bounced`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'x-csrf-token': csrf },
      credentials: 'include',
      body: JSON.stringify({ entries, year }),
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const data = await res.json();
    setMarkResult(data);
  } catch (err) {
    setMarkResult({ error: err.message });
  } finally {
    setMarking(false);
  }
};


  const fullReset = () => { setBounces([]); setFileName(""); setError(null); };

  const mkCSV = (rows) => [
    ["Recipient Email", "PPS (from address)", "Original Subject", "Sent Date", "Bounce Reason", "Message-ID"].join(","),
    ...rows.map(r => [
      `"${r.recipient}"`,
      `"${ppsHintFromEmail(r.recipient)}"`,
      `"${r.subject.replace(/"/g, '""')}"`,
      `"${r.sentDate}"`,
      `"${r.reason.replace(/"/g, '""')}"`,
      `"${r.messageId}"`,
    ].join(","))
  ].join("\n");

  const download = (csv, name) => {
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([csv], { type: "text/csv" }));
    a.download = name;
    a.click();
  };

  const counts = Object.values(CATEGORIES).reduce((acc, cat) => {
    acc[cat] = bounces.filter(r => r.category === cat).length;
    return acc;
  }, {});
  const filtered = bounces.filter(r => r.category === activeTab);

  return (
    <div style={S.root}>
      <div style={S.header}>
        <div style={S.headerTop}>
          <div>
            <div style={S.badge}>Administrator Tool</div>
            <h1 style={S.title}>Bounced Email Analyser</h1>
            <p style={S.subtitle}>Upload the SPSnotSent Outlook CSV export → extract every recipient, subject, and reason automatically</p>
          </div>
          {bounces.length > 0 && (
            <button style={{ ...S.btn, ...S.btnExport }} onClick={() => download(mkCSV(bounces), `bounced_emails_all_${new Date().toISOString().slice(0,10)}.csv`)}>
              ↓ Export All CSV
            </button>
          )}
        </div>
      </div>

      <div style={S.body}>
        {bounces.length === 0 && (
          <div style={S.infoBox}>
            <strong>How to export from Outlook:</strong> File → Open &amp; Export → Import/Export → Export to a file →
            Comma Separated Values → select the <strong>SPSnotSent</strong> folder → Save. Upload the resulting .csv below.
          </div>
        )}

        <div style={S.card}>
          {bounces.length === 0 ? (
            <div style={S.uploadBox}
              onClick={() => fileRef.current?.click()}
              onDrop={e => { e.preventDefault(); handleFile(e.dataTransfer.files[0]); }}
              onDragOver={e => e.preventDefault()}
            >
              <div style={S.uploadIcon}>📨</div>
              <div style={S.uploadText}>Click to select or drag &amp; drop your Outlook CSV export</div>
              <div style={S.uploadSub}>Reads non-delivery report (NDR) emails from the SPSnotSent folder</div>
            </div>
          ) : (
            <div style={{ marginBottom: "16px", display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
              <span style={{ fontSize: "13px", color: "#2E7D32", fontWeight: "600" }}>
                ✓ {fileName} — {bounces.length} bounce notifications parsed
              </span>
              <button style={{ ...S.btn, ...S.btnSecondary, padding: "6px 14px", fontSize: "12px" }} onClick={fullReset}>✕ Remove</button>
            </div>
          )}
          <input ref={fileRef} type="file" accept=".csv" style={{ display: "none" }} onChange={e => handleFile(e.target.files[0])} />
          {bounces.length === 0 && (
            <div style={S.controlRow}>
              <button style={{ ...S.btn, ...S.btnUpload }} onClick={() => fileRef.current?.click()}>📂 Upload CSV</button>
            </div>
          )}
          {error && <div style={S.errorBox}>⚠ {error}</div>}
        </div>

        {bounces.length > 0 && (
          <>
            <div style={S.summaryGrid}>
              {Object.values(CATEGORIES).map(cat => {
                const col = CATEGORY_COLORS[cat];
                return (
                  <div key={cat}
                    style={{ ...S.summaryCard, background: col.bg, borderLeftColor: col.border, outline: activeTab === cat ? `2px solid ${col.border}` : "none" }}
                    onClick={() => setActiveTab(cat)}
                  >
                    <div style={{ ...S.summaryCount, color: col.text }}>{counts[cat]}</div>
                    <div style={{ ...S.summaryLabel, color: col.text }}>
                      {cat === CATEGORIES.SPS && "Statement bounces"}
                      {cat === CATEGORIES.OTP && "Login code bounces"}
                      {cat === CATEGORIES.OTHER && "Other bounces"}
                    </div>
                  </div>
                );
              })}
            </div>

            <div style={S.tabRow}>
              {Object.values(CATEGORIES).map(cat => (
                <button key={cat} style={{ ...S.tab, ...(activeTab === cat ? S.tabActive : {}) }} onClick={() => setActiveTab(cat)}>
                  {cat === CATEGORIES.SPS && "Statement bounces"}
                  {cat === CATEGORIES.OTP && "Login code bounces"}
                  {cat === CATEGORIES.OTHER && "Other bounces"}
                  {" "}({counts[cat]})
                </button>
              ))}
            </div>

            <div style={S.card}>
              <h3 style={S.sectionTitle}>
                <span style={{ ...S.catBadge, background: CATEGORY_COLORS[activeTab].badge }}>{counts[activeTab]}</span>
                {CATEGORY_LABELS[activeTab]}
              </h3>

              {activeTab === CATEGORIES.SPS && (
  <div style={S.infoBox}>
    <div style={{ marginBottom: 10 }}>
      These are the people who did <strong>not</strong> receive their Annual Benefit Statement during
      the blocked sending window. The system's own records currently show these as successfully sent —
      use the button below to correct that, then resend from Email Centre using <strong>Resume</strong>.
    </div>
    <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
      <label style={{ fontSize: "12px", fontWeight: 600 }}>
        Statement year:&nbsp;
        <input
          type="number"
          value={year}
          onChange={(e) => setYear(Number(e.target.value))}
          style={{ width: "80px", padding: "4px 6px", fontFamily: "monospace", fontSize: "12px" }}
        />
      </label>
      <button
        style={{ ...S.btn, ...S.btnDanger, padding: "8px 16px", fontSize: "12px" }}
        onClick={() => setShowConfirm(true)}
        disabled={marking || filtered.length === 0}
      >
        {marking ? "Updating…" : `⚠ Mark ${filtered.length} as failed (not delivered)`}
      </button>
    </div>

    {showConfirm && (
      <div style={{ marginTop: 12, padding: "12px 14px", background: "#FFF3E0", border: "1px solid #F57C00", borderRadius: 4 }}>
        <div style={{ fontSize: 13, marginBottom: 10 }}>
          This will update <strong>{filtered.length}</strong> Email Log records for statement year{" "}
          <strong>{year}</strong> from "sent" to "failed", so Email Centre's Resume mode will
          correctly re-send to them. This cannot be automatically undone. Continue?
        </div>
        <button style={{ ...S.btn, ...S.btnDanger, padding: "6px 14px", fontSize: "12px", marginRight: 8 }} onClick={markAsFailed}>
          Yes, mark as failed
        </button>
        <button style={{ ...S.btn, ...S.btnSecondary, padding: "6px 14px", fontSize: "12px" }} onClick={() => setShowConfirm(false)}>
          Cancel
        </button>
      </div>
    )}

    {markResult && !markResult.error && (
      <div style={{ marginTop: 12, padding: "12px 14px", background: "#E8F5E9", border: "1px solid #2E7D32", borderRadius: 4, fontSize: 13 }}>
        ✓ {markResult.updated} records updated to "failed".
        {markResult.notFound > 0 && ` ${markResult.notFound} email addresses had no matching "sent" record for ${year} (already corrected, or never logged as sent).`}
      </div>
    )}
    {markResult?.error && (
      <div style={{ marginTop: 12, padding: "12px 14px", background: "#FFEBEE", border: "1px solid #EF9A9A", borderRadius: 4, fontSize: 13, color: "#B71C1C" }}>
        ✗ {markResult.error}
      </div>
    )}
  </div>
)}

              {filtered.length === 0 ? (
                <div style={S.emptyState}>No bounces in this category.</div>
              ) : (
                <>
                  <div style={{ marginBottom: "14px" }}>
                    <button style={{ ...S.btn, ...S.btnExport, padding: "7px 16px", fontSize: "12px" }}
                      onClick={() => download(mkCSV(filtered), `bounced_emails_${activeTab}_${new Date().toISOString().slice(0,10)}.csv`)}>
                      ↓ Export this list
                    </button>
                  </div>
                  <div style={{ overflowX: "auto" }}>
                    <table style={S.table}>
                      <thead>
                        <tr>
                          <th style={S.th}>#</th>
                          <th style={S.th}>Recipient</th>
                          <th style={S.th}>PPS (guess)</th>
                          <th style={S.th}>Original subject</th>
                          <th style={S.th}>Sent</th>
                          <th style={S.th}>Reason</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filtered.map((r, i) => (
                          <tr key={i} style={{ background: i % 2 === 0 ? "#FFFFFF" : "#FAF8F4" }}>
                            <td style={{ ...S.td, color: "#8C7B5E", fontFamily: "'Courier New',monospace", fontSize: "11px", width: "36px" }}>{i + 1}</td>
                            <td style={{ ...S.td, fontFamily: "'Courier New',monospace", fontSize: "12px", color: "#4A3F2E", whiteSpace: "nowrap" }}>{r.recipient}</td>
                            <td style={{ ...S.td, fontFamily: "'Courier New',monospace", fontSize: "11px" }}>
                              <span style={S.pillCode}>{ppsHintFromEmail(r.recipient)}</span>
                            </td>
                            <td style={{ ...S.td, color: "#3D3020" }}>{r.subject}</td>
                            <td style={{ ...S.td, fontSize: "12px", color: "#6B5C3E", whiteSpace: "nowrap" }}>{r.sentDate}</td>
                            <td style={{ ...S.td, fontSize: "12px", color: "#B71C1C" }}>{r.reason}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}